/* ZodiGlow streamlined mobile cart: original Shopify checkout link and single coupon remain in the footer. */
(function(){
  'use strict';
  var breakpoint=window.matchMedia('(max-width:767px)');
  var instances=new WeakMap();
  var instancesList=[];
  function newPlaceholder(node,label){
    var marker=document.createComment('zg-cart-original-'+label);
    if(node&&node.parentNode)node.parentNode.insertBefore(marker,node);
    return marker;
  }
  /* The original Liquid discount form already sits directly before checkout.
     Keep it in place and move only the optional packaging message on phones. */
  function applyLayout(instance){
    if(!instance.root.isConnected)return;
    if(breakpoint.matches){
      var benefit=instance.body.querySelector('.zodi-cart-benefit-actions');
      if(instance.packaging){
        if(benefit)benefit.after(instance.packaging);
        else instance.body.insertBefore(instance.packaging,instance.body.firstChild);
      }
      instance.root.classList.add('zg-cart-sticky-mobile');
    }else{
      instance.root.classList.remove('zg-cart-sticky-mobile');
      if(instance.packaging&&instance.packagingMarker&&instance.packagingMarker.parentNode){
        instance.packagingMarker.after(instance.packaging);
      }
    }
  }
  /* In-flow scroll affordance: visible only while more cart content is below. */
  function installCartScrollCue(instance){
    var body=instance.body;
    var drawer=instance.root.querySelector('[data-zodi-cart-drawer]');
    if(!drawer||!body.parentElement||body.parentElement!==instance.footer.parentElement)return;
    var cue=document.createElement('button');
    cue.type='button';
    cue.className='zodi-cart-scroll-cue';
    cue.setAttribute('data-zodi-cart-scroll-cue','');
    cue.setAttribute('aria-label','Scroll down to see more cart items and options');
    cue.innerHTML='<span>Scroll for more</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14m-6-6 6 6 6-6"></path></svg>';
    cue.hidden=true;
    body.after(cue);
    var frame=0;
    function update(){
      frame=0;
      if(!cue.isConnected||!body.isConnected)return;
      var remaining=Math.max(0,body.scrollHeight-body.clientHeight-body.scrollTop);
      var open=drawer.getAttribute('aria-hidden')==='false';
      cue.hidden=!(open&&!body.classList.contains('is-empty')&&body.scrollHeight-body.clientHeight>32&&remaining>14);
    }
    function schedule(){
      if(!frame)frame=window.requestAnimationFrame(update);
    }
    cue.addEventListener('click',function(){
      var remaining=Math.max(0,body.scrollHeight-body.clientHeight-body.scrollTop);
      var distance=Math.min(remaining,Math.max(140,Math.round(body.clientHeight*.72)));
      if(distance<1)return;
      var reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      body.scrollBy({top:distance,behavior:reducedMotion?'auto':'smooth'});
    });
    body.addEventListener('scroll',schedule,{passive:true});
    var contentObserver=new MutationObserver(schedule);
    contentObserver.observe(body,{childList:true,subtree:true,characterData:true});
    var drawerObserver=new MutationObserver(schedule);
    drawerObserver.observe(drawer,{attributes:true,attributeFilter:['aria-hidden']});
    var resizeObserver=typeof ResizeObserver==='function'?new ResizeObserver(schedule):null;
    if(resizeObserver){
      resizeObserver.observe(body);
      var itemList=body.querySelector('[data-zodi-cart-items]');
      if(itemList)resizeObserver.observe(itemList);
    }
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('pagehide',function(){
      contentObserver.disconnect();
      drawerObserver.disconnect();
      if(resizeObserver)resizeObserver.disconnect();
    },{once:true});
    schedule();
  }
  function initOne(root){
    if(instances.has(root))return;
    var body=root.querySelector('[data-zodi-cart-body]');
    var footer=root.querySelector('[data-zodi-cart-footer]');
    var actions=footer&&footer.querySelector('.zodi-cart-actions');
    var checkout=actions&&actions.querySelector('[data-zodi-checkout-link]');
    if(!body||!footer||!actions||!checkout)return;
    var packaging=root.querySelector('[data-zodi-packaging-promo]');
    var packagingMarker=packaging&&packaging.parentNode?newPlaceholder(packaging,'packaging'):null;
    var instance={root:root,body:body,footer:footer,actions:actions,checkout:checkout,
      packaging:packaging,packagingMarker:packagingMarker};
    instances.set(root,instance);
    instancesList.push(instance);
    applyLayout(instance);
    installCartScrollCue(instance);
  }
  function syncAll(){
    document.querySelectorAll('[id^="ZodiStandaloneDrawer-"]').forEach(initOne);
    instancesList=instancesList.filter(function(item){return item.root.isConnected});
    instancesList.forEach(applyLayout);
  }
  function boot(){
    syncAll();
    document.addEventListener('shopify:section:load',syncAll);
    var observer=new MutationObserver(function(records){
      var found=false;
      records.forEach(function(record){
        if(found)return;
        for(var i=0;i<record.addedNodes.length;i++){
          var node=record.addedNodes[i];
          if(node.nodeType===1&&(node.matches&&node.matches('[id^="ZodiStandaloneDrawer-"]') || node.querySelector&&node.querySelector('[id^="ZodiStandaloneDrawer-"]'))){found=true;break;}
        }
      });
      if(found)syncAll();
    });
    observer.observe(document.body,{childList:true,subtree:true});
    window.addEventListener('pagehide',function(){observer.disconnect()},{once:true});
  }
  if(breakpoint.addEventListener)breakpoint.addEventListener('change',syncAll);
  else if(breakpoint.addListener)breakpoint.addListener(syncAll);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
